import { render, staticRenderFns } from "./SiftSelect.vue?vue&type=template&id=5fc41230&scoped=true&"
import script from "./SiftSelect.vue?vue&type=script&lang=js&"
export * from "./SiftSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc41230",
  null
  
)

export default component.exports